export default "__VITE_PUBLIC_ASSET__441d0613__"